<template>
  <div class="uses-card">
    <div class="uses-image" :style="'background-image: url(' + image + ')'">{{title}}</div>
    <div class="uses-text">{{text}}</div>
    <div class="uses-link" v-if="link"><a :href="link.url" target="_blank">{{link.text}}</a></div>
  </div>
</template>

<script>
export default {
  name: "uses-card",
  props: {
    image: {
      type: String,
      Description: "Background image for card header."
    },
    title: {
      type: String,
      Description: "Title to display in the card header."
    },
    text: {
      type: String,
      Description: "Text to display."
    },
    link: {
      type: Object,
      Description: "Link url and text"
    }
  }
};
</script>

<style scoped lang="scss">
.uses-card {
  border: 1px solid #cccccc;
  padding: 2.5rem;
  min-height: 550px;
  margin-bottom: 2rem;
  border-radius: 4px;

  .uses-link {
    font-size: 1rem;
    font-weight: bold;
    margin-top: 12px;
  }

  .uses-image {
    background-size: cover;
    background-position: center;
    height: 275px;
    width: 100%;
    background-color: black;
    border-radius: 4px;

    color: white;
    font-size: 1.875rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .uses-text {
    margin-top: 1.5rem;
  }
}
@media (max-width: 991.98px) {
  .uses-card {
    padding: 2rem;

    .uses-image {
      font-size: 1.45rem;
    }
  }
}
</style>
